import React, { FC } from 'react';
import SquareBlock from '../SquareBlock/SquareBlock';
import DottedList from '../../../../Common/DottedList/DottedList';
import * as classes from './ServiceInfo.module.scss';
import cn from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { yearsOfExperience } from '../../../../../utils/yearsOfExperience';
import AppointmentTypesList from './AppointmentTypesList/AppointmentTypesList';
import { IAppointmentTypes } from '../../../../../interfaces/professional/Professional';

interface Props {
  specialties: Array<string>;
  helps: Array<string>;
  appointmentTypes: Array<IAppointmentTypes>;
  year?: number;
  hiddenYear?: boolean;
}

const ServiceInfo: FC<Props> = ({ specialties, helps, appointmentTypes, year, hiddenYear }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(classes.wrapper, 'row')}>
      <div className={'col-sm-6 col-12'}>
        <SquareBlock wrapperClassName={cn(classes.specialtiesWrapper, classes.squareBlock)}>
          <div className={classes.title}>{t('homePage.servicesSection.specialties')}</div>
          <DottedList items={specialties} />
        </SquareBlock>
      </div>
      <div className={'col-sm-6 col-12'}>
        <SquareBlock wrapperClassName={cn(classes.helpWrapper, classes.squareBlock)}>
          <div className={classes.title}>{t('homePage.servicesSection.canHelpYouWith')}</div>
          <DottedList items={helps} />
        </SquareBlock>
      </div>
      <div className={'col-sm-6 col-12'}>
        <SquareBlock wrapperClassName={cn(classes.appointmentTypesWrapper, classes.squareBlock)} innerClassName={classes.innerClassName}>
          <div className={classes.title}>{t('homePage.servicesSection.appointmentTypes')}</div>
          <AppointmentTypesList items={appointmentTypes} />
        </SquareBlock>
      </div>
      {year && !hiddenYear && (
        <div className={'col-sm-6 col-12'}>
          <SquareBlock wrapperClassName={cn(classes.experienceWrapper, classes.squareBlock)}>
            <div className={classes.experienceInner}>
              <div className={classes.number}>{yearsOfExperience(year)}</div>
              <div className={classes.annotation}>{t('homePage.servicesSection.yearsOfExperience')}</div>
            </div>
          </SquareBlock>
        </div>
      )}
    </div>
  );
};

export default ServiceInfo;
